import { getPromoOtt } from '../utils/get-promo-ott';

import { useReadPromoPlayerBaseInfo } from './use-read-promo-player-base-info';

export function usePromoOtt(contentId: string) {
    const trailer = useReadPromoPlayerBaseInfo(contentId);

    return trailer ? getPromoOtt(trailer) : undefined;
}
